export default {
    workOrder_main_tracker: "Órdenes de Trabajo",
    workOrder_main_customers: "Clientes",
    workOrder_main_schedule: "Programación",
};